import { BeeLoader } from './bee-loader';
import { Button } from './button';

interface ProgressLabelProps {
  label: string;
  sub?: string;
  showRetry?: boolean;
  onRetry?: () => void;
  onSwitch?: () => void;
  timedOut?: boolean;
}

/** Full-panel "searching / confirming …" state with the bee loader. */
export function ProgressLabel({
  label,
  sub,
  showRetry,
  onRetry,
  onSwitch,
  timedOut,
}: ProgressLabelProps) {
  return (
    <div
      className="wb-col wb-center"
      style={{ padding: '44px 24px', gap: 18, textAlign: 'center' }}
      role="status"
      aria-live="polite"
    >
      <BeeLoader size={62} />
      <div className="wb-col wb-center wb-gap-4">
        <div className="wb-h3">{label}</div>
        {sub && (
          <div className="wb-sub" style={{ maxWidth: 300 }}>
            {sub}
          </div>
        )}
      </div>
      <div className="wb-progress-track" style={{ width: 180 }}>
        <div className="wb-progress-indef" />
      </div>
      {(showRetry || timedOut) && (
        <div className="wb-col wb-gap-8" style={{ width: '100%', maxWidth: 300, marginTop: 6 }}>
          {timedOut && (
            <div className="wb-small" style={{ color: 'var(--honey-700)' }}>
              This is taking longer than usual.
            </div>
          )}
          <div className="wb-row wb-gap-8" style={{ justifyContent: 'center' }}>
            {onRetry && (
              <Button size="sm" variant="secondary" icon="refresh" onClick={onRetry}>
                Try again
              </Button>
            )}
            {onSwitch && (
              <Button size="sm" variant="ghost" onClick={onSwitch}>
                Try another operator
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
